<template>
    <div
        v-title="`${type == 1 || type == 2 ? merchant_name : '温馨提示'}`"
        class="home"
    >
        <div v-if="type == 1 || type == 2">
            <div class="home-payment" :style="{ background: type == 1 ? `${WeChat}` : `${Alipay}` }"
            >
                <div>
                    <img
                        v-if="type == 1"
                        src="../../assets/image/busines.jpg"
                        alt
                    />
                    <img v-else src="../../assets/image/business.png" alt/>
                    <div class="nav-items">
                        <p>{{ merchant_name }}</p>
                    </div>
                </div>
                <div class="home-payment-item">
                    <p
                        class="home-payment-item-money"
                        :style="{
                            color: type == 1 ? `${WeChat}` : `${Alipay}`,
                        }"
                    >
                        消费金额
                    </p>
                    <div class="view-input-focus">
                        {{ money }}
                    </div>
                    <KeyBoard @getMoney="getMoney" @submitPay="submitPay"></KeyBoard>
                </div>
            </div>
        </div>
        <div v-else class="home-Errors">
            <div class="home-Errors-div">
                <p class="box-title">温馨提示</p>
                <img src="@/assets/image/Sumed.png" alt/>
                <div>
                    <span class="span-ui place-use">请使用</span>
                    <span class="span-ui place-use-sao">微信，支付宝“扫一扫”</span>
                    <span class="span-ui place-use-pay"> 来完成付款！</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import KeyBoard from './keyboard'
import {aliOauth, notify, getToken} from "@/api/HOME/home"
import {Toast} from "vant"

export default {
    name: "Home",
    components: {
        KeyBoard
    },
    data() {
        return {
            url: [],
            value: "",
            WeChat: "rgba(69, 193, 102, 1)", //微信支付样式
            Alipay: "rgba(18,150,219,1)", //支付宝支付样式
            type: 1,
            show: true,
            disabled: true,
            merchant_name: "",
            mtoken: "",
            applist: " ",
            avatar: "",
            user_id: "", //支付宝
            token: "",
            total_fee: "",
            openid: "",
            types: "",
            out_trade_no: "",
            name: "",
            phone: "",
            source_mtoken: "",
            money: ""
        };
    },

    methods: {
        getMoney(data) {
            this.money = data
        },

        submitPay() {
            if (this.money != "") {
                if (this.type == 2) {
                    let data = {
                        payment_type: 3,
                        order_original_total: parseInt(Number(this.money) * 100),
                        openid: this.user_id,
                        source_mtoken: this.source_mtoken,
                        avatar: this.avatar ? this.avatar : "",
                        name: this.name,
                        phone: this.phone ? this.phone : "",
                        utoken: "alipayUsers"  // 请求接口需要，本身无意义
                    };
                    aliOauth(data)
                        .then((res) => {
                            if (res.data && res.error == 0) {
                                let date = res.data.ali_trade_no;
                                if (window.AlipayJSBridge) {
                                    this.aliJSDK(date); //调用支付宝方法进行支付
                                    this.token = res.data.token;
                                    this.types = res.data.type;
                                    this.total_fee = res.data.total_fee;
                                    // this.out_trade_no = date;
                                    this.out_trade_no = res.data.out_trade_no;
                                }
                            }else{
                                Toast.fail(res.error_reason);
                            }
                        })
                        .catch((err) => {
                            console.log(err)
                        });
                } else if (this.type == 1) {
                    let data = {
                        type: "010",
                        open_id: this.openid,
                        total_amount: this.value,
                        merchant_no: this.merchant_no,
                        // merchant_name: this.merchant_name
                    };
                    aliOauth(data)
                        .then((res) => {
                            console.log(res);
                            if (res.data && res.error == 0) {
                                this.token = res.data.token;
                                this.types = res.data.type;
                                this.total_fee = res.data.total_fee;
                                this.out_trade_no = res.data.out_trade_no;
                                // console.log(res, "我是成功页的参数");
                                let date = {
                                    appId: res.data.appId,
                                    timeStamp: res.data.timeStamp,
                                    nonceStr: res.data.nonceStr,
                                    package: res.data.package_str,
                                    signType: res.data.signType,
                                    paySign: res.data.paySign,
                                };

                                if (typeof WeixinJSBridge == "undefined") {
                                    if (document.addEventListener) {
                                        document.addEventListener(
                                            "WeixinJSBridgeReady",
                                            this.jsApiCall,
                                            false
                                        );
                                    } else if (document.attachEvent) {
                                        document.attachEvent(
                                            "WeixinJSBridgeReady",
                                            this.jsApiCall
                                        );
                                        document.attachEvent(
                                            "onWeixinJSBridgeReady",
                                            this.jsApiCall
                                        );
                                    }
                                } else {
                                    this.jsApiCall(date); //调用微信方法进行支付
                                }
                            }
                        })
                        .catch((err) => {
                            console.log(err, "失败");
                        });
                }
            } else {

                Toast("请输入金额");
            }
        },

        jsApiCall(json) {
            //微信方法进行支付
            window.WeixinJSBridge.invoke(
                "getBrandWCPayRequest",
                json,
                (res) => {
                    window.WeixinJSBridge.log(res.err_msg);
                    if (res.err_msg == "get_brand_wcpay_request:ok") {
                        // paySuccessCallback();

                        let datas = {
                            out_trade_no: this.out_trade_no,
                            total_amount: this.value,
                        };
                        notify(datas).then((res) => {
                            //后台需要的回调参数
                            if (res.error == 0) {
                                this.$router.push({
                                    //返回成功后跳转到活动页面
                                    path: "Paid",
                                    query: {
                                        token: this.token,
                                        total_fee: this.total_fee,
                                        types: this.types,
                                        user_id: this.openid,
                                    },
                                });
                            } else {
                                Toast(res.error_reason);
                            }
                        });
                    } else if (
                        res.err_msg == "get_brand_wcpay_request:cancel"
                    ) {
                        alert("已取消支付");
                    } else {
                        alert("支付失败");
                    }
                }
            );
        },

        aliJSDK(data) {
            //支付宝进行支付方法
            window.AlipayJSBridge.call("tradePay", {tradeNO: data}, () => {
                this.value = ""
            });
        },
        checkInput() {
            this.value = this.dealInputVal(this.value);
        },
        dealInputVal(value) {
            //进行input框进行判断
            value = value.replace(/^0*(0\.|[1-9])/, "$1");
            value = value.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
            value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是字符
            value = value.replace(/\.{1,}/g, "."); //只保留第一个.清除多余的
            value = value
                .replace(".", "$#$")
                .replace(/\./g, "")
                .replace("$#$", ".");
            value = value.replace(/^(-)*(\d*)\.(\d\d).*$/, "$1$2.$3"); //只能输入两个小数
            value =
                value.indexOf(".") > 0
                    ? value.split(".")[0].substring(0, 10) +
                    "." +
                    value.split(".")[1]
                    : value.substring(0, 10);
            if (value == "") {
                this.disabled = true;
            } else if (value == Number(0)) {
                this.disabled = true;
            } else if (value == "0.") {
                this.disabled = true;
            } else {
                this.disabled = false;
            }
            return value;
        },
        IsWeixinOrAlipay() {
            //判断是否是支付宝环境还是微信环境
            var ua = window.navigator.userAgent.toLowerCase();
            //判断是不是微信
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                return "1";
            }
            //判断是不是支付宝
            if (ua.match(/AlipayClient/i) == "alipayclient") {
                return "2";
            }
            //哪个都不是
            return "3";
        },
        GetQueryString(name) {
            //截取url中的参数方法
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return decodeURI(r[2]);
            return null;
        },
    },

    beforeMount() {
        // 进行参数获取GetQueryString截取方式
        if (this.GetQueryString("openid")) {
            this.openid = this.GetQueryString("openid");
        }
        if (this.GetQueryString("merchant_name")) {
            // let Base64 = require("js-base64").Base64;
            // this.merchant_name = this.GetQueryString("merchant_name");
            // this.merchant_name = Base64.decode(this.merchant_name); // delivery_asn=1
        }
        if (this.GetQueryString("mtoken")) {
            this.mtoken = this.GetQueryString("mtoken");
        }
        if (this.GetQueryString("type")) {
            if (this.GetQueryString("type") == null) {
                this.type = 3;
            } else {
                this.type = this.GetQueryString("type");
            }
        }
        if (this.GetQueryString("avatar")) {
            this.avatar = this.GetQueryString("avatar");
        }

        if (this.GetQueryString("user_id")) {
            this.user_id = this.GetQueryString("user_id");
        }
        if (this.GetQueryString("name")) {
            this.name = this.GetQueryString("name");
        }
        if (this.GetQueryString("phone")) {
            this.phone = this.GetQueryString("phone");
        }
        // 进行参数获取$route.query方式
        if (this.$route.query.merchant_name) {
            let Base64 = require("js-base64").Base64;
            this.merchant_name = this.$route.query.merchant_name;
            this.merchant_name = this.$route.query.merchant_name.split("?")[0];
            this.merchant_name = Base64.decode(this.merchant_name);
            this.openid = this.$route.query.merchant_name.split("=")[1];
        }
        if (this.$route.query.mtoken) {
            this.mtoken = this.$route.query.mtoken;

        }
        if (this.$route.query.openid) {
            this.openid = this.$route.query.openid; //ID号
        }
        if (this.$route.query.type) {
            if (this.$route.query.type == null) {
                this.type = 3;
            } else {
                this.type = this.$route.query.type;
            }
        }
        if (this.$route.query.avatar) {
            this.avatar = this.$route.query.avatar;
        }

        if (this.$route.query.user_id) {
            this.user_id = this.$route.query.user_id;
        }
        if (this.$route.query.name) {
            this.name = this.$route.query.name;
        }
        if (this.$route.query.phone) {
            this.phone = this.$route.query.phone;
        }
        getToken({mtoken: this.mtoken}).then(res => {
            if (res.error == 0 && res.data) {
                this.source_mtoken = res.data.source_mtoken
                this.token = res.data.token
                this.merchant_name = res.data.merchant_name
                sessionStorage.setItem("payToken", this.token)
            }
        })
    },
    created() {
        this.type = this.IsWeixinOrAlipay();
    },

    mounted() {
        if (window.location.href.indexOf("?#") < 0) {
            //进行改变url中哈希微信支付
            window.location.href = window.location.href.replace("#", "?#");
        }
    },
};
</script>
<style lang="scss" scoped>

.home {
    height: 100%;

    input {
        display: block !important;
    }

    .home-Errors {
        margin: 0;
        background: rgba(235, 235, 235, 1);
        width: 100%;
        height: 100%;
        position: absolute;
        overflow: hidden;

        // padding: 7.90625rem 1.125rem 1.125rem;
        text-align: center;

        p:first-child {
            padding-top: 7.90625rem;
            font-size: 1.3125rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(34, 34, 34, 1);
            margin-bottom: 1.34375rem;
        }

        img:first-child {
            width: 3.21875rem;
            height: 3.21875rem;
        }

        .home-Errors-div {
            margin-top: 0.446875rem;
            text-align: center;

            .box-title {
                color: #929191;
            }

            span {
                font-size: 1rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(153, 153, 153, 1);
            }

            span:nth-child(2) {
                font-size: 1.125rem;
                color: rgba(34, 34, 34, 1);
            }
        }
    }
}

.home-payment {
    height: 9.03125rem;
    padding: 1.46875rem 0.9375rem 0 0.9375rem;

    div:nth-child(1) {
        display: flex;
        align-items: center;

        img {
            width: 2.46875rem;
            height: 2.46875rem;
            background: rgba(255, 255, 255, 1);
            border-radius: 0.25rem;
        }

        p {
            height: 1.40625rem;
            margin-bottom: 0.0625rem;
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 1.40625rem;
        }

        .nav-items {
            display: flex;
            flex-direction: column;
            margin-left: 0.5rem;
        }
    }

    .home-payment-item {
        height: 9.03125rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 0.5rem;
        margin-top: 0.90625rem;
        position: relative;

        .home-payment-item-money {
            text-align: center;
            padding: 1rem;
            font-size: 1rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }

        h4 {
            position: absolute;
            top: 3.9375rem;
            left: 1rem;
            font-size: 1.625rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(34, 34, 34, 1);
        }

        .home-payment-input {
            width: 80%;
            border: 0;
            position: absolute;
            top: 2.34375rem;
            font-size: 3.125rem;
            left: 2.6875rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(34, 34, 34, 1);
            box-shadow: none;
        }
    }
}

.home-payment-bottom {
    padding: 0 0.9375rem 0 0.9375rem;
    background: rgba(246, 247, 249, 1);

    .home-payment-button {
        width: 100%;
        margin-top: 11.1875rem;
        height: 3.0625rem;
        color: #fff;
        border-radius: 49px;
    }
}

.view-input-focus {
    font-size: 3rem;
    line-height: 3rem;
    height: 3rem;
    text-align: left;
    padding-left: 10px;
    display: inline-block;
    position: relative;
}

.view-input-focus::before {
    content: '￥';
    font-size: 2rem;
    color: #222222;
}

.view-input-focus::after {
    content: '';
    width: 4px;
    height: 3rem;
    background: #45C166;
    position: absolute;
    right: -0.4rem;
    top: 50%;
    margin-top: -1.5rem;
    animation: showhide 1.5s infinite;
}

@keyframes showhide {
    0% {
        opacity: 0;
    }

    50% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}
</style>
